import clsx from 'clsx'

import { Shimmer } from '@wartek-id/shimmer'

import type { FC } from 'react'

interface DataBlockLoadingProps {
  direction?: 'vertical' | 'horizontal'
  index: number
}

const DataBlockLoading: FC<DataBlockLoadingProps> = ({
  direction = 'vertical',
  index,
}) => {
  const widthLabel = index % 2 === 1 ? 65 : 75
  return (
    <div
      className={clsx({
        flex: true,
        'flex-col space-y-1': direction === 'vertical',
        'flex-row': direction === 'horizontal',
      })}
    >
      <div className="basis-2/5">
        <Shimmer
          width={`${
            direction === 'horizontal' ? widthLabel : widthLabel - 20
          }%`}
        />
      </div>
      <div className="basis-3/5">
        <Shimmer width={index % 2 === 1 ? '95%' : '85%'} />
      </div>
    </div>
  )
}
export default DataBlockLoading
